var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{ref:"appHeader",staticClass:"fixed",class:{'floating': _vm.floatingHeader, 'transparent': _vm.transparentTop },attrs:{"clean":true}}),_vm._v(" "),_c('div',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }